(function() {
  // Load the external script source dynamically
  const scriptElement = document.createElement('script');
  scriptElement.src = 'https://fingerprint-sdk-shopify.pages.dev/regular@0.0.1.js';
  document.head.appendChild(scriptElement);
})()